<template>
  <g id="mechanic">
    <path
      class="cls-3"
      d="M1358.4 916.5h-72.5c-68.6 0-121.8-60-113.6-128.1l14.2-117.1A136.6 136.6 0 011322.2 551a136.8 136.8 0 01135.7 120.3l14.1 117.1c8.2 68.1-45 128.1-113.6 128.1z"
      transform="translate(17)"
    />
    <path
      class="cls-4"
      d="M1465.7 1020h-286.5v-.3a131.9 131.9 0 0162.5-112.2l4.8-2.8a131.1 131.1 0 0164.7-16.9h22.3a131.9 131.9 0 0164.9 17l4.8 2.8a132.4 132.4 0 0162.5 112.4z"
      transform="translate(17)"
    />
    <path
      class="cls-5"
      d="M1403.2 907.6v3.4a80.8 80.8 0 01-161.5 0v-3.5l4.8-2.8a131.1 131.1 0 0164.7-16.9h22.3a131.9 131.9 0 0164.9 17z"
      transform="translate(17)"
    />
    <path
      class="cls-6"
      d="M1295.4 855h88.1v43.7a43.9 43.9 0 01-43.9 43.9h-.1a44.1 44.1 0 01-44.1-44.1V855z"
    />
    <path
      class="cls-5"
      d="M1432.4 707v60.6a110.2 110.2 0 01-220.4 0V707z"
      transform="translate(17)"
    />
    <path
      class="cls-7"
      d="M1388.3 766.8a66.4 66.4 0 01-3.7 22 64.5 64.5 0 01-31.7 36.6 66.8 66.8 0 01-61.9-.2 65.1 65.1 0 01-31.3-36.4 66.3 66.3 0 01-3.6-22z"
      transform="translate(17)"
    />
    <path
      class="cls-8"
      d="M1388.3 766.8a66.4 66.4 0 01-3.7 22h-124.9a66.3 66.3 0 01-3.6-22z"
      transform="translate(17)"
    />
    <path
      class="cls-9"
      d="M1352.9 825.4a66.8 66.8 0 01-61.9-.2 33.2 33.2 0 0161.9.2z"
      transform="translate(17)"
    />
    <path
      class="cls-6"
      d="M1320.1 709.2h38.2v20a19.1 19.1 0 01-19.1 19.1 19.1 19.1 0 01-19.1-19.1v-20z"
    />
    <path
      class="cls-7"
      d="M1310.5 707h-8.8c.1 1.4.3 2.9.3 4.4s-.2 3-.3 4.4a32.7 32.7 0 01-64.8 0 32.4 32.4 0 010-8.8h-8.9a32.5 32.5 0 00-.3 4.4 31.5 31.5 0 00.3 4.4 41.5 41.5 0 0082.5 0 31.5 31.5 0 00.3-4.4 32.5 32.5 0 00-.3-4.4zM1416.3 707h-8.9a32.4 32.4 0 010 8.8 32.7 32.7 0 01-64.8 0 32.4 32.4 0 010-8.8h-8.8a32.5 32.5 0 00-.3 4.4 31.5 31.5 0 00.3 4.4 41.5 41.5 0 0082.5 0 31.5 31.5 0 00.3-4.4 32.5 32.5 0 00-.3-4.4z"
      transform="translate(17)"
    />
    <path
      class="cls-5"
      d="M1275.3 653.5H1403a46.3 46.3 0 0146.3 46.3v7.2H1229v-7.1a46.3 46.3 0 0146.3-46.4z"
    />
    <path
      class="cls-10"
      d="M1282.5 712.5a13.2 13.2 0 11-13.2-13.2 13.2 13.2 0 0113.2 13.2z"
      transform="translate(17)"
    />
    <circle class="cls-10" cx="1392.1" cy="712.5" r="13.2" />
    <path class="cls-7" d="M1229 707h220.4v8.81H1229z" />
  </g>
</template>